import { createFileRoute } from '@tanstack/react-router';

import { SecurityPage } from '../../auth/security-page';

/**
 * `/account/security` (M2.7).
 *
 * No `RequirePermission`: these are the staff member's own credentials, and every clinic
 * role may manage them. The route sits behind `RequireAuth` and `RequireMfa` through the
 * root layout like every other screen.
 */
export const Route = createFileRoute('/account/security')({
  component: SecurityPage,
});
